import { Modal, Button, Alert } from 'react-bootstrap';
import { IAddEditData } from './add-edit-data';

interface IProps {
    show: boolean,
    data: IAddEditData,
    onConfirm: () => void,
    onCancel: () => void
}

const ConfirmDeactivation = (props: IProps) => {
    const isDeactivating = props.data != null && props.data.isDeactivated;
    const firstName = props.data != null ? props.data.firstName : '';
    const lastName = props.data != null ? props.data.lastName : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm {isDeactivating ? 'Deactivation' : 'Reactivation'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle={isDeactivating ? 'danger' : 'warning'} bsSize='sm'>
                    {isDeactivating
                        ? <>Are you sure you want to deactivate {firstName} {lastName}? They will no longer be able to log in.</>
                        : <>Are you sure you want to reactivate {firstName} {lastName}?</>}
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle={isDeactivating ? 'danger' : 'warning'} onClick={props.onConfirm}>Yes</Button>
                <Button onClick={props.onCancel}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDeactivation;
